import React from 'react';
import { Button } from '../ui/button';
import { FOCUS_FILTERS } from './workItemQueueFilters';

/**
 * Clickable mission-control count tiles.
 * @param {{ counts: Record<string, number>, activeId: string|null, onSelect: (id: string|null) => void }} props
 */
const WorkItemActionStrip = ({ counts = {}, activeId, onSelect }) => (
  <div className='flex flex-wrap gap-2'>
    {FOCUS_FILTERS.map((f) => {
      const n = counts[f.id] || 0;
      const active = activeId === f.id;
      const urgent = f.id === 'overdue' && n > 0;
      return (
        <Button
          key={f.id}
          size='sm'
          variant={active ? 'default' : 'outline'}
          className={
            urgent && !active
              ? 'border-destructive text-destructive hover:bg-destructive/10'
              : undefined
          }
          onClick={() => onSelect(active ? null : f.id)}>
          {f.label}
          <span className='ml-1.5 tabular-nums opacity-80'>{n}</span>
        </Button>
      );
    })}
  </div>
);

export default WorkItemActionStrip;
